import { Status } from './status';

export default {
  status: Status.IDLE,
  error: undefined,
  data: undefined,
};
